import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import SearchOneGTIN from '../consultas/search_one/gtin';
import SearchOneGLN from '../consultas/search_one/gln';
import SearchOneOtherKeys from '../consultas/search_one/otherKeys';
import SearchManyGTIN from '../consultas/search_many/gtin';
import './style.css';
import SearchManyGLN from '../consultas/search_many/gln';
import ModalChangeScreen from '../../components/ModalChangeScreen';
import { useSelector } from '../../native-state.dev';
import SearchManyOtherKeys from '../consultas/search_many/otherKeys';
import SearchOneFindCompany from '../consultas/search_one/findCompany';
import { IoMdArrowDropright, IoMdArrowDropleft } from 'react-icons/io';
import SearchOneNCM from '../consultas/search_one/search-NCM';
import SearchGTINsrelationship from '../consultas/field-NCP-GPC';
import SearchOneSimilares from '../consultas/search_one/search-similares';
import { Tooltip } from "react-tooltip";

const MENSAGEM_TOOLTIP_EXPERIMENTE =
  'Funcionalidades ou atributos que contenham a sinalização "Experimente" estão disponíveis gratuitamente por um período limitado.';

const ExperimenteTag = () => (
  <span
    className="experimenteTag"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '6px',
      backgroundColor: '#F26334',
      color: '#FFFFFF',
      padding: '4px 10px',
      borderRadius: '16px',
      fontSize: '12px',
      fontWeight: '600',
      width: 'fit-content',
      cursor: 'pointer',
    }}
  >
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width="12" 
      height="12" 
      fill="currentColor" 
      className="bi bi-star" 
      viewBox="0 0 16 16"
    >
      <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z"/>
    </svg>
    Experimente
  </span>
);

interface ChooseSearchProps {
  handleTab: (tab: string) => void;
  activeTab: string;
  multiple: boolean;
}

const ChooseSearch: React.FC<ChooseSearchProps> = ({
  handleTab,
  activeTab,
  multiple,
}) => {
  const [searchDone, setState] = useSelector(
    (s: { searchDone: boolean }) => s.searchDone
  );

  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const [isOpenModalRequest, setIsOpenModalRequest] = useState(false);
  const [pendingTab, setPendingTab] = useState<string | null>(null);
  const location = useLocation();
  const carouselRef = useRef<HTMLDivElement | null>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const items = multiple ? [1, 2, 3] : [1, 2, 3, 4, 5, 6, 7, 8];
  const itemsPerPage = 4;
  const totalPages = Math.ceil(items.length / itemsPerPage);

  const handleScroll = () => {
    if (!carouselRef.current) return;

    const { scrollLeft, clientWidth, scrollWidth } = carouselRef.current;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);

    const centerPosition = scrollLeft + clientWidth / 2;

    const cardWidth =
      carouselRef.current.firstElementChild instanceof HTMLElement
        ? carouselRef.current.firstElementChild.offsetWidth + 20
        : 0;

    const centerItemIndex = Math.min(
      Math.floor(centerPosition / cardWidth),
      items.length - 1
    );

    const pageIndex = Math.min(
      Math.floor(centerItemIndex / itemsPerPage),
      totalPages - 1
    );

    setActiveIndex(pageIndex);
  };

  useEffect(() => {
    if (multiple) return;

    handleScroll();

    const carousel = carouselRef.current;

    if (!carousel) return;

    carousel.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      carousel.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, [multiple, items.length]);

  const currentPath = location.pathname.split('/').pop();

  const handleModalClick = (tab: string) => {
    if (searchDone) {
      setPendingTab(tab);
      setIsOpenModalRequest(true);
    } else {
      handleTab(tab);
    }
  };

  const checkScroll = () => {
    if (!carouselRef.current) return;

    const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;

    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 1);
  };

  const scrollCarousel = (direction: 'left' | 'right') => {
    if (multiple || !carouselRef.current) return;

    const cardWidth =
      carouselRef.current.firstElementChild instanceof HTMLElement
        ? carouselRef.current.firstElementChild.offsetWidth + 20
        : 0;

    if (direction === 'left') {
      carouselRef.current.scrollLeft -= cardWidth * 3;
      setActiveIndex((prev) => Math.max(prev - 1, 0));
    } else {
      carouselRef.current.scrollLeft += cardWidth * 3;
      setActiveIndex((prev) => Math.min(prev + 1, totalPages - 1));
    }

    setTimeout(checkScroll, 100);
  };

  const handleChangeScreen = () => {
    setState({ searchDone: false });
    setIsOpenModalRequest(false);

    if (pendingTab) {
      handleTab(pendingTab);
      setPendingTab(null);
    }
  };

  const closeModal = () => {
    setIsOpenModalRequest(false);
    setPendingTab(null);
  };

  const exportB = () => {
    setIsOpenModalRequest(false);

    const exportButton = document.getElementsByName(
      'buttonExport'
    )[0] as HTMLButtonElement | undefined;

    exportButton?.click();
  };

  return (
    <>
      <div className="row rowTitleApis">
        <div className="col-12 col-md-8 pt-md-0">
          <h1 className="gs1-h1 titlePrincipal" style={{ color: '#002c6c' }}>
            <img src="/check-green.png" className="imgcheck-green" alt="" />
            Verified by GS1
          </h1>

          <p className="titleDescriptionMin">
            Verifique a identidade de produtos com base em informações confiáveis
            de donos de marcas
          </p>
        </div>
      </div>

      {!multiple && (
        <div className="bannerTotCustom">
          <div className="carouselWrapper">
            <div
              className="carouselBtn left"
              style={{ marginLeft: '-25px' }}
              onClick={() => scrollCarousel('left')}
            >
              <IoMdArrowDropleft
                size={55}
                color={canScrollLeft ? '#002C6C' : '#C4D7ED'}
              />
            </div>

            <div className="rowBoxApiCustoum bgBoxApi" ref={carouselRef}>
              <div
                className={
                  activeTab === 'tab1' ? 'boxApiActiveCustom' : 'boxApiCustom'
                }
                onClick={() => handleModalClick('tab1')}
              >
                <label>
                  <div className="boxContent">
                    <img
                      src="/gtin.svg"
                      width="76"
                      height="45"
                      className="boxIcon"
                      alt=""
                    />
                    <h4
                      className="boxTitle custom-font-size"
                      style={{ maxWidth: '160px' }}
                    >
                      Verificar Produto
                    </h4>
                    <p className="boxSubtitle">
                      Busque através do número do código de barras (GTIN)
                    </p>
                  </div>
                </label>
              </div>

              <div
                className={
                  activeTab === 'tab2' ? 'boxApiActiveCustom' : 'boxApiCustom'
                }
                onClick={() => handleModalClick('tab2')}
              >
                <label>
                  <div className="boxContent">
                    <img
                      style={{ marginLeft: '-19px' }}
                      src="/gln.svg"
                      width="76"
                      height="45"
                      className="boxIcon"
                      alt=""
                    />
                    <h4 className="boxTitle custom-font-size">
                      Verificar Localização
                    </h4>
                    <p className="boxSubtitle">
                      Busque através da chave de localização (GLN)
                    </p>
                  </div>
                </label>
              </div>

              <div
                className={
                  activeTab === 'tab3' ? 'boxApiActiveCustom' : 'boxApiCustom'
                }
                onClick={() => handleModalClick('tab3')}
              >
                <label>
                  <div className="boxContent">
                    <img
                      src="/other-keys.svg"
                      width="45"
                      height="45"
                      className="boxIcon"
                      alt=""
                    />
                    <h4 className="boxTitle custom-font-size">
                      Verificar Outras Chaves
                    </h4>
                    <p className="boxSubtitle">Busque por outras chaves</p>
                  </div>
                </label>
              </div>

              {currentPath === 'homeApi' && (
                <div
                  className={
                    activeTab === 'tab4'
                      ? 'boxApiActiveCustom'
                      : 'boxApiCustom'
                  }
                  onClick={() => handleModalClick('tab4')}
                >
                  <label>
                    <div className="boxContent">
                      <img
                        src="/company-name.svg"
                        width="45"
                        height="45"
                        className="boxIcon"
                        alt=""
                      />
                      <h4 className="boxTitle custom-font-size">
                        Verificar Empresas
                      </h4>
                      <p className="boxSubtitle">
                        Pesquisar por nome da empresa e país
                      </p>
                    </div>
                  </label>
                </div>
              )}

              <div
                className={
                  activeTab === 'tab5' ? 'boxApiActiveCustom' : 'boxApiCustom'
                }
                onClick={() => handleModalClick('tab5')}
              >
                <label>
                  <div className="boxContent">
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <img
                        src="/upc-now(1).svg"
                        width="35"
                        height="35"
                        className="boxIcon"
                        alt=""
                      />
                      <img
                        src="/globe-now.svg"
                        width="35"
                        height="35"
                        className="boxIcon"
                        alt=""
                      />
                    </div>
                    <h4 className="boxTitle custom-font-size">
                      Consultar por GPC/NCM
                    </h4>
                    <p className="boxSubtitle">
                      Busque GTINs nacionais por GPC ou NCM
                    </p>
                    <ExperimenteTag />
                  </div>
                </label>
              </div>

              <div
                className={
                  activeTab === 'tab6' ? 'boxApiActiveCustom' : 'boxApiCustom'
                }
                onClick={() => handleModalClick('tab6')}
              >
                <label>
                  <div className="boxContent">
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <img
                        src="/upc-now(1).svg"
                        width="35"
                        height="35"
                        className="boxIcon"
                        alt=""
                      />
                      <img
                        src="/link-now.svg"
                        width="35"
                        height="35"
                        className="boxIcon"
                        alt=""
                      />
                    </div>
                    <h4 className="boxTitle custom-font-size">
                      GTINs Relacionados
                    </h4>
                    <p className="boxSubtitle">
                      Busque por GTINs nacionais relacionados
                    </p>
                    <ExperimenteTag />
                  </div>
                </label>
              </div>

              <div
                className={
                  activeTab === 'tab7' ? 'boxApiActiveCustom' : 'boxApiCustom'
                }
                onClick={() => handleModalClick('tab7')}
              >
                <label>
                  <div className="boxContent">
                    <img
                      src="/gtin.svg"
                      width="76"
                      height="45"
                      className="boxIcon"
                      alt=""
                    />
                    <h4 className="boxTitle custom-font-size">
                      GTINs Similares
                    </h4>
                    <p className="boxSubtitle">Consultar por GTINs similares</p>
                    <ExperimenteTag />
                  </div>
                </label>
              </div>
            </div>

            <div
              className="carouselBtn right"
              style={{ marginRight: '-25px' }}
              onClick={() => scrollCarousel('right')}
            >
              <IoMdArrowDropright
                size={55}
                color={canScrollRight ? '#002C6C' : '#C4D7ED'}
              />
            </div>
          </div>

          <div className="carouselDots">
            {Array.from({ length: totalPages }).map((_, i) => (
              <div
                key={i}
                style={{
                  width: 30,
                  height: 3,
                  borderRadius: 4,
                  backgroundColor: i === activeIndex ? '#C4D7ED' : '#002C6C',
                  transition: 'background-color 0.3s',
                }}
              />
            ))}
          </div>
        </div>
      )}

      {multiple && (
        <div className="bannerTotCustom">
          <div className="rowBoxApiCustoum bgBoxApi">
            <div
              className={
                activeTab === 'tab1' ? 'boxApiActiveCustom' : 'boxApiCustom'
              }
              onClick={() => handleModalClick('tab1')}
            >
              <label>
                <div className="boxContent">
                  <img
                    src="/gtin.svg"
                    width="76"
                    height="45"
                    className="boxIcon"
                    alt=""
                  />
                  <h4
                    className="boxTitle custom-font-size"
                    style={{ maxWidth: '160px' }}
                  >
                    Verificar Produto
                  </h4>
                  <p className="boxSubtitle">
                    Busque através do número do código de barras (GTIN)
                  </p>
                </div>
              </label>
            </div>

            <div
              className={
                activeTab === 'tab2' ? 'boxApiActiveCustom' : 'boxApiCustom'
              }
              onClick={() => handleModalClick('tab2')}
            >
              <label>
                <div className="boxContent">
                  <img
                    style={{ marginLeft: '-19px' }}
                    src="/gln.svg"
                    width="76"
                    height="45"
                    className="boxIcon"
                    alt=""
                  />
                  <h4 className="boxTitle custom-font-size">
                    Verificar Localização
                  </h4>
                  <p className="boxSubtitle">
                    Busque através da chave de localização (GLN)
                  </p>
                </div>
              </label>
            </div>

            <div
              className={
                activeTab === 'tab3' ? 'boxApiActiveCustom' : 'boxApiCustom'
              }
              onClick={() => handleModalClick('tab3')}
            >
              <label>
                <div className="boxContent">
                  <img
                    src="/other-keys.svg"
                    width="45"
                    height="45"
                    className="boxIcon"
                    alt=""
                  />
                  <h4 className="boxTitle custom-font-size">
                    Verificar Outras Chaves
                  </h4>
                  <p className="boxSubtitle">Busque por outras chaves</p>
                </div>
              </label>
            </div>
          </div>
        </div>
      )}

      <div>
        {!multiple ? (
          activeTab === 'tab1' ? (
            <SearchOneGTIN />
          ) : activeTab === 'tab2' ? (
            <SearchOneGLN />
          ) : activeTab === 'tab3' ? (
            <SearchOneOtherKeys />
          ) : activeTab === 'tab4' ? (
            <SearchOneFindCompany />
          ) : activeTab === 'tab5' ? (
            <SearchOneNCM />
          ) : activeTab === 'tab6' ? (
            <SearchGTINsrelationship />
          ) : (
            <SearchOneSimilares />
          )
        ) : activeTab === 'tab1' ? (
          <SearchManyGTIN />
        ) : activeTab === 'tab2' ? (
          <SearchManyGLN />
        ) : (
          <SearchManyOtherKeys />
        )}
      </div>

      <ModalChangeScreen
        isOpen={isOpenModalRequest}
        onClose={closeModal}
        onChangeScreen={handleChangeScreen}
        onExport={exportB}
      />

      <Tooltip
        anchorSelect=".experimenteTag"
        content={MENSAGEM_TOOLTIP_EXPERIMENTE}
        style={{
          width: '360px',
          maxWidth: '360px',
          padding: '10px 14px',
          borderRadius: '4px',
          textAlign: 'left',
          lineHeight: '1.4',
          fontSize: '13px',
          zIndex: 9999,
        }}
      />
    </>
  );
};

export default ChooseSearch;